/**
 * Entry: bind PDF summary workflow to wholesale contact forms.
 * Wait until Alpine has bound its capture submit handler, then bind ours after it.
 */

import { bindAllWholesalePdfForms } from 'ak-pdf/formSubmission.js';

window.bindAllWholesalePdfForms = bindAllWholesalePdfForms;

function init() {
  bindAllWholesalePdfForms();
}

function initAfterAlpine() {
  // Register after Alpine's capture listener so capture order is: Alpine → PDF
  if (window.Alpine) {
    document.addEventListener('alpine:initialized', () => {
      queueMicrotask(init);
    }, { once: true });

    // Alpine may already be initialized
    queueMicrotask(init);
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      queueMicrotask(init);
    });
  } else {
    queueMicrotask(init);
  }
}

initAfterAlpine();
